import {useState} from "react"
import {Button, Dialog, Text, Tile} from "@wakelet/ui-kit";
import {translateKey} from "../language/translate";

type DeleteAccountTileProps = {
  onDelete: () => void
}

export const DeleteAccountTile = ({onDelete}: DeleteAccountTileProps) => {
  const [dialogOpen, setDialogOpen] = useState(false)

  return <Tile negative={true} data-testid={"delete-account-tile"}>
    <Text.Heading level={3}>{translateKey("account:delete.title")}</Text.Heading>
    <Text.Paragraph>{translateKey("account:delete.info.paragraph1")}</Text.Paragraph>
    <Text.Paragraph>{translateKey("account:delete.info.paragraph2")}</Text.Paragraph>
    <Text.Paragraph data-testid={"delete-info-paragraph3"}>
      {translateKey("account:delete.info.paragraph3")}{" "}
      <a href="mailto: support@wakelet.com"><b>support@wakelet.com</b></a>
    </Text.Paragraph>
    <div className="flex justify-end">
      <Button data-testid="delete-account-btn" className="w-64 my-3" variant="negative" type="submit"
              onClick={() => setDialogOpen(true)}>
        <Button.Label text={translateKey("account:delete.buttonLabel")}/>
      </Button>
    </div>
    <Dialog data-testid="delete-account-dialog"
            title={translateKey("account:delete.title")}
            open={dialogOpen}
            onClose={() => setDialogOpen(false)}
    >
      <Text.Paragraph>{translateKey("account:delete.dialog.confirmMessage")}</Text.Paragraph>
      <div className="flex justify-end gap-3 mt-3 mr-4">
        <Button data-testid="delete-account-btn-cancel"
                variant="secondary"
                onClick={() => setDialogOpen(false)}
        >
          <Button.Label text={translateKey("account:delete.dialog.cancelLabel")}/>
        </Button>
        <Button data-testid="delete-account-btn-confirm"
                variant="negative"
                onClick={() => {
                  setDialogOpen(false)
                  onDelete()
                }}
        >
          <Button.Label text={translateKey("account:delete.dialog.confirmLabel")}/>
        </Button>
      </div>
    </Dialog>
  </Tile>
}
